import { api } from '@/api/api';

export const campaign = {
  namespaced: true,
  state: {
    fetchingList: false,
    list: [],
  },
  getters: {
    empty(state) {
      return state.list.length === 0;
    },
  },
  mutations: {
    setFetching(state, fetching) {
      state.fetchingList = fetching;
    },
    setCampaigns(state, campaigns) {
      state.list = campaigns;
    },
    addCampaign(state, campaign) {
      state.list.push(campaign);
    },
  },
  actions: {
    async fetchCampaigns({ rootState, commit }) {
      if (rootState.company.currentId === -1) {
        return;
      }
      commit('setFetching', true);
      const { data } = await api.get(
        `companies/${rootState.company.currentId}/campaigns/`
      );
      commit(
        'setCampaigns',
        data.map((campaign) => ({
          ...campaign,
          editing: false,
        }))
      );
      commit('setFetching', false);
    },
    async updateCampaign({ rootState, state, commit }, campaign) {
      await api.patch(
        `companies/${rootState.company.currentId}/campaigns/${campaign.id}/`,
        campaign
      );
      commit(
        'setCampaigns',
        state.list.map((s) => {
          if (s.id === campaign.id) {
            return campaign;
          }
          return s;
        })
      );
    },
    async addCampaign({ rootState, commit }, campaign) {
      const { data } = await api.post(
        `companies/${rootState.company.currentId}/campaigns/`,
        campaign
      );
      const newCampaign = {
        ...data,
        editing: false,
      };
      commit('addCampaign', newCampaign);
    },
  },
};
